import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

export const SORT_DIRECTION = {
  unsorted: 0,
  ascending: 1,
  descending: 2,
};

export class SortableFilterableTableHeader extends React.Component {
  static propTypes = {
    onSort: PropTypes.func,
    onFilter: PropTypes.func,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    onSort: null,
    onFilter: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      sortDirection: SORT_DIRECTION.unsorted,
      isFiltered: false,
      filter: '',
    };
  }

  handleFilterChange(e) {
    const filter = e.target.value;

    this.setState(
      { filter },
      () => this.sendOnFilter(),
    );
  }

  toggleSortDirection(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.setState(state => ({
      sortDirection: (state.sortDirection + 1) % 3,
    }), () => this.props.onSort && this.props.onSort(this.state.sortDirection));
  }

  sendOnFilter() {
    if (!this.props.onFilter) return;

    this.props.onFilter(this.state.isFiltered ? this.state.filter : '');
  }

  toggleIsFiltered(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.setState(state => ({
      isFiltered: !state.isFiltered,
    }), () => {
      this.sendOnFilter();

      if (this.state.isFiltered) {
        this.filterInput.focus();
        setTimeout(() => {
          this.filterInput.selectionStart = this.state.filter.length;
          this.filterInput.selectionEnd = this.state.filter.length;
        }, 0);
      }
    });
  }

  clearFilter(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.setState(
      { filter: '' },
      () => this.sendOnFilter(),
    );
  }

  renderSortIndicator() {
    return (
      <a href="#" onClick={e => this.toggleSortDirection(e)} alt="Sort" style={{ marginRight: '4px', outline: 'none' }}>
        {this.state.sortDirection === SORT_DIRECTION.unsorted && (<span className="pe-7s-angle-down" style={{ opacity: 0.5 }}><span className="sr-only">No sort</span></span>)}
        {this.state.sortDirection === SORT_DIRECTION.ascending && (<span className="pe-7s-angle-up"><span className="sr-only">Sort ascending</span></span>)}
        {this.state.sortDirection === SORT_DIRECTION.descending && (<span className="pe-7s-angle-down"><span className="sr-only">Sort descending</span></span>)}
      </a>
    );
  }

  renderFilterIndicator() {
    return (
      <a href="#" onClick={e => this.toggleIsFiltered(e)} alt="Filter" style={{ outline: 'none' }}>
        {this.state.isFiltered && (<span className="pe-7s-filter"><span className="sr-only">Filter is applied</span></span>)}
        {!this.state.isFiltered && (<span className="pe-7s-filter" style={{ opacity: 0.5 }}><span className="sr-only">Filter is cleared</span></span>)}
      </a>
    );
  }

  renderFilter() {
    return (
      <div className="form-group">
        <span className="clearable-input">
          <input
            ref={c => (this.filterInput = c)}
            value={this.state.filter}
            onChange={e => this.handleFilterChange(e)}
          />
          <button type="button" onClick={e => this.clearFilter(e)} />
        </span>
      </div>
    );
  }

  render() {
    return (
      <th>
        {this.props.children}
        <span style={{ float: 'right' }}>
          {this.props.onSort && this.renderSortIndicator()}
          {this.props.onFilter && this.renderFilterIndicator()}
        </span>
        {this.state.isFiltered && this.renderFilter()}
      </th>
    );
  }
}

export function filterSimpleColumn(source, columnName, state) {
  const filter = state[`${columnName}Filter`].trim();

  if (!filter) return source;

  const regex = new RegExp(filter, 'ig');

  return source.filter(x => x[columnName].match(regex));
}

export function filterSimpleColumns(source, state, ...columns) {
  return source.filter(x => _.every(columns, c => {
    const filter = state[`${c}Filter`];
    return !filter || x[c].match(new RegExp(filter.trim(), 'ig'));
  }));
}

export function sortSimpleColumn(source, columnName, state) {
  const direction = state[`${columnName}SortDirection`];

  if (direction === SORT_DIRECTION.unsorted) return source;

  const sortedSource = source.sortBy(x => x[columnName]);

  return direction === SORT_DIRECTION.ascending ? sortedSource : sortedSource.reverse();
}
